import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useAuth } from "../context/AuthContext";
import pic from "../assets/pinnacleWhiteLogo.svg";

const TypingParagraph = () => {
  const { exam, category } = useParams();
  const navigate = useNavigate();
  const [paragraphs, setParagraphs] = useState([]);
  const [cookies] = useCookies(["token"]);
  const { user } = useAuth();

  const startTyping = (code) => {
    navigate(`/typingmodule/${code}/${exam}/${category}`);
  };

  useEffect(() => {
    const fetchParagraphs = async () => {
      try {
        const res = await fetch(
          "https://auth.ssccglpinnacle.com/api/typingParagraphs",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
            body: JSON.stringify({ exam }),
          }
        );
        if (res.ok) {
          const data = await res.json();
          setParagraphs(data);
        } else {
          navigate("/");
        }
      } catch (error) {
        navigate("/");
      }
    };

    const checkAccess = async () => {
      if (!cookies.token) return navigate("/");
      try {
        const res = await fetch(
          "https://auth.ssccglpinnacle.com/api/checkAccessTypingProduct",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${cookies.token}`,
            },
            body: JSON.stringify({ product_id: "999" }),
          }
        );
        const result = await res.json();
        if (result.access === "access") {
          fetchParagraphs();
        } else {
          navigate("/");
        }
      } catch {
        navigate("/");
      }
    };

    checkAccess();
  }, [cookies.token, exam, navigate]);

  return (
    <div className="min-h-screen bg-white">
      {/* Blue Header */}
      {/* Blue Header */}
      <div className="bg-blue-700 py-3 px-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 text-white">
        <div className="flex items-center justify-between w-full sm:w-auto">
          <img
            src={pic}
            alt="Logo"
            className="h-6 md:h-4 xl:h-6 sm:h-8 cursor-pointer"
            onClick={() => navigate("/")}
          />
          <span className="block sm:hidden text-sm font-normal">
            {user?.email_id || "Loading..."}
          </span>
        </div>

        <p className="text-center w-full sm:flex-1 text-sm sm:text-base md:text-lg font-normal">
          Typing Software 2026
        </p>

        <span className="hidden sm:block text-sm">
          {user?.email_id || "Loading user data..."}
        </span>
      </div>
      {/* Paragraphs */}
      <div className="py-6 px-4 space-y-6">
        {paragraphs.map((para, index) => (
          <div
            key={index}
            onClick={() => startTyping(para.paper_code)}
            className="rounded cursor-pointer mx-2 sm:mx-4 md:mx-8 lg:mx-12 px-4 sm:px-6 md:px-8 py-6 sm:py-8 text-white shadow-md transition transform hover:scale-[1.01] bg-blue-600 hover:bg-green-600"
          >
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 items-center mb-2 text-sm font-normal">
              <span>{para.paper_code}</span>
              <span>{para.date || ""}</span>
              <span className="uppercase">{para.type}</span>
              <span className="text-right w-full">Start Typing</span>
            </div>
            <h5 className="text-sm sm:text-base leading-relaxed mt-2">
              {para.paragraph}
            </h5>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TypingParagraph;
